export default {
  // 课程
  competitionCourseList: '/competition_course/list',
  competitionCourseDetail: '/competition_course/detail',
  competitionCourseStore: '/competition_course/store',
  competitionCourseUpdate: '/competition_course/update',
  competitionCourseDelete: '/competition_course/delete',


}